<script setup lang="ts">
import { TuiModalFunctionsHost } from '@clickbar/tailwindui-vue'
import * as Sentry from '@sentry/vue'
import { whenever } from '@vueuse/core'
import { Toaster } from 'vue-sonner'

import AppCommandPalette from '@/Components/AppCommandPalette.vue'
import SidebarNavigation from '@/Components/Sidebar/SidebarNavigation.vue'
import { useFlashToast, useNavigation, useUser } from '@/Composables/spaceship'
import { persistenceStatus } from '@/lib/startupPerformance'

const navigation = useNavigation()

useFlashToast()

const user = useUser()
whenever(
  user,
  () => {
    Sentry.setUser({ id: user.value?.id })
  },
  { immediate: true },
)
</script>

<template>
  <div class="flex h-full">
    <div class="flex-none">
      <SidebarNavigation :items="navigation!" />
    </div>

    <main class="relative isolate min-h-dvh min-w-0 grow" :data-persistence="persistenceStatus">
      <slot />
    </main>

    <TuiModalFunctionsHost />

    <AppCommandPalette />

    <Toaster position="bottom-right" rich-colors />
  </div>
</template>
